export const zoneConfig = {
    max: {
        zoneIds: 3000,
        domains: 500,
        adslotIds: 500,
    }
}
